<template>
   <div id="participants" :class="{ live : this.$props.l}">
    <p id="participants-handle" :class="{ live : this.$props.l}">Participants</p>
    <ul id="participants-content">
      <li v-if="this.residency1">
        <p>
          Shiyun
        </p>
        </li>
      <li>
        <p>
          you
        </p>
      </li>
      <li id ="list-participant" v-for="participant in participantlist" :key="participant.key">
            <p>{{ participant[1].username }}</p>
      </li>
    </ul>
    <button
      id="changeRoom"
      v-show="roomConnection != null && loading == false"
      v-on:click="$emit('changeRoom')"
    >Leave Room</button>
  </div>
</template>

<script>
import interactions from "../interactions";

export default {
  name: "Participants",
  props: ["participantlist", "roomConnection", "loading", "l", "residency1"],
  data() {
    return {
      x: null,
      y: null,
      fold: false,
      ratioLock: false
    }
  },
    mounted() {
    interactions.dragDrop("#participants", "#participants-handle", this.x, this.y);
  },


  created(){
    // console.log(this.participantlist);
    this.participantlist.forEach(e => {
      // console.log(e.identity);
      
    });
  }
}
</script>

<style scoped>
ul {
  margin: 0;
  padding:0;
}

li {
  list-style-type: none;
}
li p {
  padding:5px;
  font-size:16px;
}

li:first-child p {
  padding-top:10px;
}

li:last-child p {
  padding-bottom:10px;
}



#participants {
  position:absolute;
  padding:0;
  margin-left: 230px;
  z-index:1000;
}

#participants-handle {
  position: sticky;
  border-bottom: 1px solid black;
  top: 0;
  margin: 0;
  font-size: 16px;
  margin-block-start: 0;
  padding: 5px;
  background-color: #dbfcf0;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
  z-index: 10010;
}

p#participants-handle.live {
  background-color: #6d6d6d;
}

#participants-content {
  width:200px;
  height:100px;
  overflow-y: auto;
}

#participants.live button {
  color:rgb(235, 235, 235);
  background-color: #464646;
}

button {
  margin:10px 5px 5px 5px;
  width: calc(100% - 10px);
}
</style>